export interface BlockstreamAddressTxoStatsDto {
  fundedTxoCount: number;
  fundedTxoSum: number;
  spentTxoCount: number;
  spentTxoSum: number;
  txCount: number;
}

export interface BlockstreamAddressStatsDto {
  address: string;
  chainStats: BlockstreamAddressTxoStatsDto;
  mempoolStats: BlockstreamAddressTxoStatsDto;
}

interface BlockstreamAddressTxoStatsApiResponse {
  funded_txo_count: number;
  funded_txo_sum: number;
  spent_txo_count: number;
  spent_txo_sum: number;
  tx_count: number;
}

interface BlockstreamAddressStatsApiResponse {
  address: string;
  chain_stats: BlockstreamAddressTxoStatsApiResponse;
  mempool_stats: BlockstreamAddressTxoStatsApiResponse;
}

function mapTxoStats(stats: BlockstreamAddressTxoStatsApiResponse): BlockstreamAddressTxoStatsDto {
  return {
    fundedTxoCount: stats.funded_txo_count,
    fundedTxoSum: stats.funded_txo_sum,
    spentTxoCount: stats.spent_txo_count,
    spentTxoSum: stats.spent_txo_sum,
    txCount: stats.tx_count,
  };
}

export function blockstreamAddressStatsFromApiResponse(
  response: BlockstreamAddressStatsApiResponse,
): BlockstreamAddressStatsDto {
  return {
    address: response.address,
    chainStats: mapTxoStats(response.chain_stats),
    mempoolStats: mapTxoStats(response.mempool_stats),
  };
}

export function blockstreamAddressStatsHasTransactions(
  stats: BlockstreamAddressStatsDto,
): boolean {
  return stats.chainStats.txCount > 0 || stats.mempoolStats.txCount > 0;
}
